import { queryOptions } from '@tanstack/react-query';

import type { UserSettingsPageData } from './get-user-settings-page-data.ts';
import { getUserSettingsPageData } from './get-user-settings-page-data.ts';

export const USER_SETTINGS_PAGE_QUERY_KEY = ['user-settings-page'] as const;

export function getUserSettingsPageDataQueryOptions() {
	return queryOptions<UserSettingsPageData>({
		queryFn: () => getUserSettingsPageData(),
		queryKey: USER_SETTINGS_PAGE_QUERY_KEY,
	});
}
